export default "__VITE_ASSET__DdCnID$Q__"